import React from "react";
import { SupplierController } from "./SupplierController";
import { SupplierViewModel } from "./SupplierViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class SupplierProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new SupplierViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <SupplierController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Supplier/SupplierProvider.js